import { Primitive } from 'type-fest';
import { values } from 'lodash';

export default function checkValueInObj<T extends { [key: string]: Primitive }>(
    obj: T,
    value: Primitive
): value is T[keyof T] {
    return values(obj).includes(value);
}
